<template>

<div class="help-center-home">
    <div class="help-center-home-header">
        <h1>How can we help you?</h1>
        <input type="search" v-model="kbItemsSearchTerm" placeholder="Start typing to search...">
        <ul class="filtered-search-kb-items" v-if="filteredSearchKbItems.length > 0">
            <li v-for="(item, index) in filteredSearchKbItems">
                <router-link :to="'/help-center/articles/' + item.kb_item_id">{{ item.category }}<template v-if="item.category != item.topic"> - {{ item.topic }}</template></router-link>
            </li>
        </ul>
        <p style="margin: 1em;">- or -</p>
        <h3>Choose a Topic</h3>
    </div>
    <div class="three-columns help-center-home-content">
        <div class="two-columns column span-two">
            <h3 class="span-two">Common Problems</h3>
            <ul v-for="(n, index) in commonItemsColumns">
                <li v-for="(item, itemIndex) in commonItems" v-if="itemIndex >= (index * 4) && itemIndex < (n * 4)">
                    <router-link :to="'/help-center/articles/' + item.kb_item_id">
                        {{ item.category }}
                        <template v-if="item.category != item.topic"> - {{ item.topic }}</template>
                    </router-link>
                </li>
            </ul>
        </div>
        <div class="column">
            <h3>Quick Start Guides</h3>
            <ul>
                <li>Coming Soon!</li>
            </ul>
        </div>
        <h3 class="span-all">All Help Articles</h3>
        <div v-for="(item, index) in getKBMenu">
            <h4><router-link :to="'/help-center/articles/' + item.kb_item_id">{{ item.topic }}</router-link></h4>
            <ul>
                <li v-for="(subItem, index) in item.sub_menu" v-if="index < 4"><router-link :to="'/help-center/articles/' + subItem.kb_item_id">{{ subItem.topic }}</router-link></li>
                <li><router-link :to="'/help-center/articles/' + item.kb_item_id">More...</router-link></li>
            </ul>
        </div>

    </div>

    <div class="open-support-tickets">
        <h3 v-if="supportTickets.length > 0">Your open support tickets</h3>
        <h3 v-else>You have no open support tickets</h3>
        <div class="inner-content">
            <div v-if="supportTickets.length > 0" class="support-ticket-list-heading">
                <span>Subject</span><span>Priority</span><span>Last Reply</span><span>From</span><span>Status</span>
            </div>
            <router-link :to="'/help-center/support-tickets-detail/' + supportTicket.support_ticket_id + (token ? '?fd_token=' + token : '')" tag="div" v-for="(supportTicket, index) in supportTickets" :key="index" class="support-ticket-list">
                <span>{{ supportTicket.topic }}</span>
                <span>{{ supportTicket.support_ticket_priority_code }}</span>
                <span>{{ supportTicket.support_ticket_detail_time }}</span>
                <span>{{ supportTicket.user_name }}</span>
                <span>{{ supportTicket.support_ticket_status_code }}</span>
            </router-link>
            <router-link tag="button" :to="'/help-center/support-tickets' + (this.token ? '?fd_token=' + this.token : '')" class="button action">See All Support Tickets</router-link>
        </div>
    </div>

    <h1>CDS Video Library</h1>
	<ul class="resources-grid">
        <li v-for="(video, index) in videos" class="video-section">
            <div class="iframe-container">
                <iframe :src="'https://player.vimeo.com' + (video.uri).replace('videos', 'video')" class="iframe" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>

                <!-- <iframe :src="'https://player.vimeo.com' + video.uri" class="iframe" allow="autoplay; fullscreen" allowfullscreen></iframe> -->
            </div>
            <h3>{{ video.title }}</h3>
        </li>
        <li class="full-width-video video-section">
            <div class="iframe-container">
                <iframe src="https://player.vimeo.com/video/498450062" class="iframe" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
            </div>
        </li>
    </ul>

    <div v-if="!loading" class="help-center-support-bar">
        Didn't find what you need? <router-link tag="button" :to="'/help-center/support-tickets-detail/new' + (this.token ? '?fd_token=' + this.token : '')" class="button action">Open a Support Ticket</router-link>
    </div>
    <div class="loading full-page" v-if="loading"><i class="fas fa-spinner fa-spin"></i></div>
</div>

</template>

<script>
import { mapGetters, mapActions } from "vuex"
export default {
    name: 'help-center-home',
    data() {
        return {
            kbItemsSearchTerm: null,
            searchKbItems: [],
            kbItems: [],
            supportTickets: [],
            token: '',
            videos: []
        }
    },
    created() {
        this.token = this.$route.query.fd_token
        this.fetchData()
    },
    computed: {
        ...mapGetters('dashboard_module', [
            'getSearchKbItems',
            'getKBMenu'
        ]),
        loading() {
            return this.getSearchKbItems.length == 0 || this.getKBMenu.length == 0
        },
        filteredSearchKbItems() {
            if (!this.kbItemsSearchTerm) {
                return []
            }
            var filteredSearchKbItems = this.getSearchKbItems.filter(item => {
                return item.search_text.toLowerCase().indexOf(this.kbItemsSearchTerm.toLowerCase()) > -1
            })
            return filteredSearchKbItems
        },
        commonItems() {
            return this.getSearchKbItems.filter(item => item.common == "1")
        },
        commonItemsColumns() {
            return Math.ceil(this.commonItems.length / 4)
        }
    },
    methods: {
        fetchData() {
            let data = {
                page: 1,
                filter: "NOT_CLOSED"
            }
            if (this.token) {
                data.fd_token = this.token
            }
            this.apiCall({ destination: 'get_list_support_tickets', data: data }).then(obj => {
                this.supportTickets = obj.support_tickets
            }).catch(err => {
                console.log(err);
            })
            this.apiCall({ destination: 'get_list_support_videos' }).then(obj => {
                this.videos = obj.videos
            }).catch(err => {
                console.log(err);
            })
        }
    }
}
</script>

<style lang="scss" scoped>
h1 { margin: 1em 0;}
input {
    font-size: 1.5em;
    padding: 1.25em 1em;
}

.help-center-support-bar {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 1em;
    font-size: 1.25em;
    background-color: #d3d3d3;
    text-align: center;
    .button { margin-left: 1em; }
}

.open-support-tickets {
    border: 1px solid #ccc;
    padding: 0;
    margin: 0 0 3em 0;
    h3 {
        font-size: 1.25em;
        margin: 0;
        padding: .25em .5em;
        background-color: #dfdce3;
    }
    .inner-content {
        padding: 1em;
    }
}

ul.resources-grid {
    margin: 2em 0 4em 0;
    list-style: none;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 1em;
    padding: 0 2em;
    li.video-section {
        text-align: center;
        h3 { margin: 0.5em 0 1em 0;}
        .iframe-container {
            position: relative;
            overflow: hidden;
            padding-top: 56.25%;
        }
        .iframe {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border: 0;
        }
    }
    li.full-width-video {
        grid-column: 1 / 3;
    }
}
</style>
